import { motion } from 'framer-motion';
import { useTranslation } from 'react-i18next';
import { IoClose } from 'react-icons/io5';
import { useAppConfig } from '../../../hooks/use-app-config';

export function ErrorMessage({ handleClose }: { handleClose: () => void }) {
  const { t } = useTranslation(undefined, { keyPrefix: 'checkout' });
  const { featureFlags } = useAppConfig();
  const redirectUrl = localStorage.getItem('redirectUrl') || '';

  return (
    <div className="success-wrapper">
      <section className="success">
        {!featureFlags?.checkout_deeplinks_disable_store && !redirectUrl && (
          <div className="close-icon" onClick={handleClose}>
            <IoClose size={24} color="white" />
          </div>
        )}
        <motion.h1>{t('ohNo')}</motion.h1>
        <motion.h4>{t('somethingWentWrong')}</motion.h4>
        {redirectUrl && (
          <button
            className="redirect-button"
            style={{
              backgroundColor: 'white',
              color: 'black',
              marginTop: '1em',
              width: 'fit-content',
            }}
            onClick={() => {
              localStorage.removeItem('redirectUrl');
              window.location.href = redirectUrl;
            }}
          >
            {t('returnToGame')}
          </button>
        )}
      </section>
    </div>
  );
}
